import {
  Avatar,
  Box,
  Chip,
  Divider,
  Drawer,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import CloseIcon from "src/assets/svg-icons/close.svg";
import PersonIcon from "@mui/icons-material/Person";
import moment from "moment";

interface IProps {
  open: boolean;
  onClose: any;
  shiftDetails: any;
}

const RowDetailsDrawer = ({ open, onClose, shiftDetails }: IProps) => {
  console.log({ shiftDetails });

  type RoleKey = "supervisor" | "locationManager" | "zoneManager";

  const roleLabels = {
    supervisor: "Supervisor",
    locationManager: "Location Manager",
    zoneManager: "Zone Manager",
    supervisorAssistant: "Supervisor Assistant",
  };

  return (
    <Drawer anchor={"right"} open={open} onClose={onClose}>
      <Box
        minWidth={{ xs: "100vw", md: "570px" }}
        maxWidth={{ xs: "100vw", md: "570px" }}
        padding={"40px 30px"}
      >
        {/* header */}
        <Stack
          direction={"row"}
          justifyContent={"space-between"}
          alignItems={"center"}
          borderBottom={"1px solid #454343"}
          paddingBottom={"29px"}
        >
          <Typography>Shift Requests Details</Typography>
          <IconButton sx={{ p: "0" }} onClick={onClose}>
            <img src={CloseIcon} alt="" />
          </IconButton>
        </Stack>
        {/* content */}
        <Box paddingY={"26px"}>
          {shiftDetails?.requests?.length > 0 ? (
            <>
              {shiftDetails?.requests?.map((req: any) => {
                return (
                  <>
                    {/* request */}
                    <Stack gap={2} direction={"row"}>
                      <Box
                        display={"flex"}
                        flexDirection={"column"}
                        width={"fit-content"}
                        alignItems={"center"}
                      >
                        <Avatar sx={{ mb: 1 }}>
                          <PersonIcon />
                        </Avatar>
                        <Box
                          height={"40px"}
                          width={"2px"}
                          bgcolor={"#757575"}
                        />
                      </Box>
                      <Stack
                        width={"100%"}
                        direction={"row"}
                        justifyContent={"space-between"}
                        gap={2}
                      >
                        <Stack>
                          <Typography fontSize={"16px"}>
                            {req.requestedByName}
                          </Typography>
                          <Typography
                            textTransform={"capitalize"}
                            fontSize={"14px"}
                            color={"gray"}
                          >
                            {req.requestType === "extend"
                              ? "Overtime"
                              : req.requestType}{" "}
                            request
                          </Typography>
                        </Stack>

                        <Box>
                          <Typography color={"gray"} fontSize={"14px"}>
                            {moment(req.requestedAt).format("DD MMMM, YYYY")}
                          </Typography>
                          <Typography color={"gray"} fontSize={"14px"}>
                            {moment(req.requestedAt).format("hh:mm A")}
                          </Typography>
                        </Box>
                      </Stack>
                    </Stack>
                    {/* reviewers */}
                    {(req.reviewedRoles ?? []).map((roleAction: any) => {
                      const role: RoleKey = roleAction.role;
                      return (
                        <Stack mt={2} gap={2} direction={"row"}>
                          <Box
                            display={"flex"}
                            flexDirection={"column"}
                            width={"fit-content"}
                            alignItems={"center"}
                          >
                            <Avatar sx={{ mb: 1 }}>
                              <PersonIcon />
                            </Avatar>
                            <Box
                              height={"40px"}
                              width={"2px"}
                              bgcolor={"#757575"}
                            />
                          </Box>
                          <Stack
                            width={"100%"}
                            direction={"row"}
                            justifyContent={"space-between"}
                          >
                            <Stack>
                              <Box mb={1.5}>
                                <Typography fontSize={"16px"}>
                                  {roleAction.name ?? ""}{" "}
                                </Typography>
                                <Typography fontSize={"14px"} color={"gray"}>
                                  ({roleLabels[role] || role})
                                </Typography>
                              </Box>
                              <Chip
                                variant="outlined"
                                color={
                                  roleAction.status === "pending"
                                    ? "warning"
                                    : roleAction.status === "approved"
                                      ? "success"
                                      : "error"
                                }
                                size="small"
                                label={roleAction.status}
                                sx={{
                                  textTransform: "capitalize",
                                  width: "fit-content",
                                }}
                              />
                            </Stack>

                            {roleAction.reviewedAt && (
                              <Box>
                                <Typography color={"gray"} fontSize={"14px"}>
                                  {moment(roleAction.reviewedAt).format(
                                    "DD MMMM, YYYY",
                                  )}
                                </Typography>
                                <Typography color={"gray"} fontSize={"14px"}>
                                  {moment(roleAction.reviewedAt).format(
                                    "hh:mm A",
                                  )}
                                </Typography>
                              </Box>
                            )}
                          </Stack>
                        </Stack>
                      );
                    })}
                    <Divider sx={{ my: 1 }} />
                  </>
                );
              })}
            </>
          ) : (
            <Box>
              <Typography textAlign={"center"}>No Requests</Typography>
            </Box>
          )}
        </Box>
      </Box>
    </Drawer>
  );
};

export default RowDetailsDrawer;
